import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import moment from "moment-timezone";
import DayPicker from 'react-day-picker';
import { Input } from "../input";
import { format } from 'date-fns';
import { CommonText } from '../../bumpViews/commonText';
import { IconCalendarAlt } from '../../icons/order-icons-v2';
import { ArrowDownIcon } from '../select/icon';
const DatePickerFooter = styled("div") `
    margin: 0 1em;
`;
export const MobileModal = styled.div `
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: ${({ customBackground }) => customBackground ? customBackground : "rgba(28, 28, 28, 0.20)"};
    position: fixed;
    height: 100%;
    z-index: 100;
    bottom: 0;
    left: 0;
`;
export const MobileContent = styled.div `
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: fixed;
    height: fit-content;
    z-index: 101;
    top: 30%;
    left: 5vw;
    max-width: 90vw;
    @media (min-width: 767px) {
        top: 50%;
        left: 50%;
        max-width: 800px;
        margin-top: calc(-21vh);
        margin-left: -370px; 
    }
    
`;
export const DateDisplayWrapper = styled.div `
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    background-color: white;
    padding: 8px 16px;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
    
`;
const Wrapper = styled("div") `
  position: relative;
  input{
    border: 1px solid #DFDFDF;
    border-radius: 4px;
    height: 40px;
    width: 100%;
    ${({ version }) => version === 'v1' ?
    css `padding: 8px 12px 8px 43px;` :
    css `padding: 1rem;padding-right: 2rem;`};
    font-family: Inter;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
  }
  svg {
        position: absolute;
        top: 50%;
        ${({ version }) => version === 'v1' ? css `left: 12px;` : css `right: 12px;`};
        transform: translateY(-50%);
        display: inline-block;
    }
  .modal-wrapper {
    background: white;
    border: 1px solid ${({ theme }) => theme.input.border};
    display: ${({ active }) => active ? "block" : "none"};
    .DayPicker{
        width: 100%;
        height: 350px;
        border-bottom-right-radius: 8px;
        border-bottom-left-radius: 8px;
        .DayPicker-wrapper{
            height: 100%;
            
            .DayPicker-Months{
                height: 100%;
            }
        }
        .DayPicker-NavButton{
            width: 2.25em;
            height: 2.25em;
            top: 8px;
        }
        .DayPicker-Day--today{
            color: #FB2F2F;
        }
        .DayPicker-NavButton--prev{
            left: 1.5rem;
            background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIj4KPHBhdGggZD0iTTE1LjcwNSA3LjQxTDE0LjI5NSA2TDguMjk1MDQgMTJMMTQuMjk1IDE4TDE1LjcwNSAxNi41OUwxMS4xMjUgMTJMMTUuNzA1IDcuNDFaIiBmaWxsPSIjNDk0NTRGIi8+Cjwvc3ZnPg==");
        }
        .DayPicker-NavButton--next{
            background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIj4KPHBhdGggZD0iTTkuNzA1MDQgNkw4LjI5NTA0IDcuNDFMMTIuODc1IDEyTDguMjk1MDQgMTYuNTlMOS43MDUwNCAxOEwxNS43MDUgMTJMOS43MDUwNCA2WiIgZmlsbD0iIzQ5NDU0RiIvPgo8L3N2Zz4=")
        }
        .DayPicker-Month{
            width: 100%;
            .DayPicker-Caption{
                text-align: center;
                padding: 8px 16px;
                & > div {
                    font-family: Roboto;
                    color: #49454F;
                }
            }
            .DayPicker-Week .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover {
                background-color: #FB2F2F !important;
                border-radius: 8px;
            }
            .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
                background-color: #FB2F2F !important;
                color: white !important;
                border-radius: 8px;
            }
        }
    }
  }
`;
export const DateInputV2 = (props) => {
    const [modal, setModal] = useState(false);
    const { disabled, onSelect, date, displayFormat = 'DD/MM/YYYY', timezone = moment.tz.guess(), className, numberOfMonths = 1, modifiers, version = 'v1' } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(Wrapper, { active: modal, className: className, version: version },
            version === 'v1' && React.createElement(IconCalendarAlt, null),
            React.createElement(Input, { readOnly: true, value: moment.tz(date, timezone).format(displayFormat), onFocus: () => {
                    setModal(true);
                } }),
            version === 'v2' && React.createElement(ArrowDownIcon, null),
            React.createElement("div", { className: "modal-wrapper" },
                React.createElement(MobileModal, { onClick: () => {
                        setModal(false);
                    } }),
                React.createElement(MobileContent, null,
                    React.createElement(DateDisplayWrapper, null,
                        React.createElement(CommonText, { size: 'large', weight: 600, color: '#4B4F5E' }, date && format(date, 'EEE, MMMM dd'))),
                    React.createElement(DayPicker, { selectedDays: date, onDayClick: onSelect, disabledDays: disabled, numberOfMonths: numberOfMonths, modifiers: modifiers })),
                React.createElement(DatePickerFooter, null)))));
};
//# sourceMappingURL=index.js.map